import { render, staticRenderFns } from "./NewDelhi.vue?vue&type=template&id=bb32ab10&"
import script from "./NewDelhi.vue?vue&type=script&lang=js&"
export * from "./NewDelhi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports